/**
 * ScheduleManagementPage - Schedule management
 *
 * Surfaces the ScheduleManager from @ferp/workflow-forms for admin/architect users.
 * Provides full CRUD management of workflow schedules and time-based triggers.
 *
 * Route: /admin/schedule-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons-react';

import { ScheduleManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ScheduleManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconCalendarEvent size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Schedule Management</Title>
            <Text size="sm" c="dimmed">
              Manage workflow schedules, cron jobs, and time-based triggers
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ScheduleManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default ScheduleManagementPage;
